import axiosInstance from "./AxiosInstance";

// Create a new lead note
export const createLeadNote = async (noteData) => {
  return axiosInstance.post("/lead/addNote", noteData);
};

// Get all notes for a specific lead
export const getLeadNotes = async (lead_id) => {
  return axiosInstance.post("/lead/noteList", { lead_id });
};

// Format the notes response data
export function formatLeadNotes(responseData) {
  if (!responseData) return [];

  if (Array.isArray(responseData)) {
    return responseData.map(note => ({
      ...note,
      note_id: note.note_id || note._id || note.id,
    }));
  }

  const notes = [];
  for (let key in responseData) {
    if (responseData.hasOwnProperty(key)) {
      notes.push({
        ...responseData[key],
        note_id:
          responseData[key].note_id ||
          responseData[key]._id ||
          responseData[key].id ||
          key,
      });
    }
  }

  console.log("formattedLeadNotes:", notes);
  return notes;
}
